export default {
  zh: {
    titles: {
      sharedToUsers: '分享给其他用户'
    }
  },
  en: {
    titles: {
      sharedToUsers: 'Add Users to Share'
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/ui/Modals/i18n.js